<script setup lang="ts">
import UIHeader from '@/components/ui/UIHeader.vue'
import UIModal, {
  UIModalBody,
  UIModalCancelButton,
  UIModalFooter,
  UIModalSubmitButton
} from '@/components/ui/UIModal'
import useLanguage from '@/composables/useLanguage'
import { useConfirmStore } from '@/store/confirm'
import { PhTrash } from '@phosphor-icons/vue'
import { onMounted, ref } from 'vue'

const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
}>()

const i18n = useLanguage('UIModal')
const confirmStore = useConfirmStore()
const firstElement = ref<typeof UIModalCancelButton | undefined>()

const onSubmit = (evt) => {
  emit('confirm')
  evt.preventDefault()
}

onMounted(() => {
  firstElement.value?.$el.focus()
})
</script>

<template>
  <UIModal
    v-if="confirmStore.isOpen"
    id="confirm-modal"
    :label-id="`confirm-modal-header-${confirmStore.key}`"
    :description-id="`confirm-modal-description-${confirmStore.key}`"
  >
    <UIHeader
      :id="`confirm-modal-header-${confirmStore.key}`"
      :text="confirmStore.header"
      :variant="confirmStore.variant"
    />
    <form @submit="onSubmit">
      <UIModalBody
        :id="`confirm-modal-description-${confirmStore.key}`"
        variant="coloredHeader"
        >{{ confirmStore.text }}</UIModalBody
      >
      <UIModalFooter>
        <UIModalCancelButton ref="firstElement" @click="$emit('cancel')" />
        <UIModalSubmitButton
          variant="filled"
          :color="
            confirmStore.variant == 'destructive' ? 'destructive' : 'primary'
          "
          class="flex items-center whitespace-nowrap"
        >
          <PhTrash
            v-if="
              confirmStore.confirmBtn === 'delete' ||
              confirmStore.confirmBtn === 'remove'
            "
            :size="16"
          />
          {{ i18n[confirmStore.confirmBtn] }}
        </UIModalSubmitButton>
      </UIModalFooter>
    </form>
  </UIModal>
</template>
